import React from 'react';

export default function CategoryPills({ categories = [], selected, onSelect, hidden = false }) {
    // Multi-row layout (wrap), matching Retailers Website (no horizontal scroll).
    // Round 4: `hidden` slides the bar upward off-screen (transform only, GPU-cheap)
    // while keeping the sticky reference so it can slide back in on scroll-up.
    return (
        <div
            className={`sticky top-[52px] z-30 glass-sticky border-b border-sdf-line transition-transform duration-200 will-change-transform ${hidden ? '-translate-y-full pointer-events-none' : 'translate-y-0'}`}
            data-testid="category-pills-bar"
            aria-hidden={hidden}
        >
            <div className="max-w-6xl mx-auto px-3 sm:px-4 py-3">
                <div className="flex flex-wrap gap-2 justify-start">
                    {categories.map((c) => {
                        const active = c.slug === selected;
                        return (
                            <button
                                key={c.slug}
                                onClick={() => onSelect(c.slug)}
                                data-testid={`pill-${c.slug}`}
                                className={`whitespace-nowrap px-4 py-2 rounded-full text-sm font-semibold transition-colors border ${active ? 'bg-sdf-red text-white border-sdf-red shadow-sm' : 'bg-white text-sdf-text border-sdf-line hover:bg-neutral-50'}`}
                            >
                                {c.name}
                            </button>
                        );
                    })}
                </div>
            </div>
        </div>
    );
}
